import React from 'react';

import { InventoryTabItemName } from '../../../../../InventoryStore';
import {
  useInventoryHeaderState,
  useInventoryState,
} from '../../../../../hooks';
import { useReadOnlyRowConfig } from '../../../../../hooks/useReadOnlyRowConfig';
import { isDateAfterEndOfSale, isDatePast } from '../../../../../utils';
import type { PackDetails } from '../../../../../utils/packs';
import { LabelCell } from '../../../../Table/Cells/LabelCell/LabelCell';
import { LabelValueCell } from '../../../../Table/Cells/LabelValueCell/LabelValueCell';
import { PureFieldCell } from '../../../../Table/Cells/PureFieldCell/PureFieldCell';
import { TableRow } from '../../../../Table/TableRow/TableRow';

const PackBookingsRowComponent: React.FC<{ packId: number }> = ({ packId }) => {
  const { isEditMode } = useInventoryHeaderState();

  const { inventoryPacks, dateKeys } = useReadOnlyRowConfig(
    InventoryTabItemName.Packs
  );

  const { endOfSaleDate } = useInventoryState();

  if (!inventoryPacks) {
    return null;
  }

  return (
    <TableRow>
      <LabelCell label="Bookings" />
      {dateKeys.map((dateKey) => {
        const fieldName = [dateKey, `${packId}`];
        const bookedStockFieldName = [...fieldName, 'booked'];
        const isGrayed =
          isDatePast(dateKey) || isDateAfterEndOfSale(dateKey, endOfSaleDate);

        return (
          <PureFieldCell key={dateKey} name={fieldName} dateKey={dateKey}>
            {(values?: PackDetails) => {
              if (!values) {
                return null;
              }

              return (
                <LabelValueCell
                  value={values?.booked ?? 0}
                  label={
                    values.maxBooking !== undefined && !isEditMode
                      ? `(max ${values.maxBooking})`
                      : undefined
                  }
                  labelPosition="bottom"
                  date={dateKey}
                  name={bookedStockFieldName}
                  grayed={isGrayed}
                />
              );
            }}
          </PureFieldCell>
        );
      })}
    </TableRow>
  );
};

export const PackBookingsRow = React.memo(PackBookingsRowComponent);
